<div class="container mt-4">

	<!-- Loading -->
	<div *ngIf="!filteredHistories" class="d-flex align-items-center mb-3">
		<span class="me-2">Loading</span>
		<div class="spinner-border text-primary" role="status" style="width: 1.5rem; height: 1.5rem;"></div>
	</div>

	<!-- No Logs Message -->
	<div *ngIf="filteredHistories && filteredHistories.length === 0" class="alert alert-warning">
		No logs available.
	</div>

	<!-- Chemical History Table -->
	<div *ngIf="filteredHistories && filteredHistories.length > 0" class="card shadow-sm">
		<div class="card-body">
			<h3 class="card-title mb-3">Chemical History</h3>

			<ngb-accordion #acc="ngbAccordion" activeIds="panel-0">
				<ngb-panel *ngFor="let item of filteredHistories; let i = index" id="panel-{{ i }}" title="{{ item.description }} ({{ item.createdDate | date:'M/d/yyyy' }})">
					<ng-template ngbPanelContent>

						<!-- General Readings -->
						<div class="row small mb-3">
							<div class="col-sm-6">
								<ul class="list-unstyled mb-0">
									<li><strong>LSI:</strong> {{ item.lsiCurrent }} → {{ item.lsiDesired }}</li>
									<li><strong>pH:</strong> {{ item.phCurrent }} → {{ item.phDesired }}</li>
									<li><strong>Alkalinity:</strong> {{ item.totalAlkalinityCurrent }} → {{ item.totalAlkalinityDesired }}</li>
									<li><strong>Calcium:</strong> {{ item.calciumCurrent }} → {{ item.calciumDesired }}</li>
									<li><strong>CYA:</strong> {{ item.cyaCurrent }} → {{ item.cyaDesired }}</li>
									<li><strong>Chlorine:</strong> {{ item.chlorineCurrent }} → {{ item.chlorineDesired }}</li>
								</ul>
							</div>
							<div class="col-sm-6">
								<ul class="list-unstyled mb-0">
									<li><strong>Borates:</strong> {{ item.boratesCurrent }} → {{ item.boratesDesired }}</li>
									<li><strong>Phosphates:</strong> {{ item.phosphateCurrent }} → {{ item.phosphateDesired }}</li>
									<li><strong>Salt:</strong> {{ item.saltCurrent }} → {{ item.saltDesired }}</li>
									<li><strong>Temp (°F):</strong> {{ item.waterTemperatureCurrentF }} → {{ item.waterTemperatureDesiredF }}</li>
									<li><strong>Volume (gals):</strong> {{ item.volume }}</li>
									<li><strong>Technician:</strong> {{ item.userName }}</li>
								</ul>
							</div>
						</div>

						<!-- Actions -->
						<div *ngIf="getSummaryActionKeys(item).length > 0" class="mt-3">
							<h6 class="fw-bold">Dosing Actions</h6>
							<ul class="ps-3 small">
								<li *ngFor="let key of getSummaryActionKeys(item)">
									{{ key }}: {{ getSummaryActions(item, key) }}
								</li>
							</ul>
						</div>

						<!-- Maintenance -->
						<div *ngIf="getSummaryMaintenanceKeys(item).length > 0" class="mt-3">
							<h6 class="fw-bold">Maintenance</h6>
							<ul class="ps-3 small">
								<li *ngFor="let key of getSummaryMaintenanceKeys(item)">
									{{ key }}: {{ getSummaryMaintenance(item, key) }}
								</li>
							</ul>
						</div>

						<button *ngIf="CanDeleteLogs" class="btn btn-sm btn-danger" (click)="deleteHistory(item)">
							Delete
						</button>

					</ng-template>
				</ngb-panel>
			</ngb-accordion>
		</div>
	</div>
</div>
